module.exports = __webpack_public_path__ + "img/05_C_T.86c3f9b6.png";